import ENV from "../env";

export interface Font {
  src?: string | null;
  srcFormat?: string | null;
  fontWeight?: string | null;
  fontStyle?: string | null;
  fontDisplay?: string | null;
}

export interface BackgroundColors {
  navbar?: string | null;
  page?: string | null;
}

export interface Colors {
  primary?: string | null;
  secondary?: string | null;
  text?: string | null;
  success?: string | null;
  error?: string | null;
  background?: BackgroundColors;
}

export interface Fonts {
  fontFamily?: string | null;
  light?: Font;
  lightItalic?: Font;
  italic?: Font;
  regular?: Font;
  medium?: Font;
  semibold?: Font;
  bold?: Font;
}

export interface BrandingModel {
  platformName?: string | null;
  colors?: Colors;
  fonts?: Fonts;
  customVariables?: { [key: string]: string } | null;
}

const getBranding = async (): Promise<BrandingModel> => {
  const response = await fetch(`${ENV.API_SERVER}/v1/style/branding`, {
    method: "GET",
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch branding: ${response.status}`);
  }

  return response.json() as Promise<BrandingModel>;
};

const getStylesheet = async (): Promise<string> => {
  const response = await fetch(`${ENV.API_SERVER}/v1/style/branding.css`, {
    method: "GET",
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch branding CSS: ${response.status}`);
  }

  return response.text();
};

export const branding = {
  getBranding,
  getStylesheet,
};
